module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('BreadcrumbsLayout', {
    attrs: {
      "breadcrumbs": _vm.breadcrumbsExtended
    }
  }, [(_vm.isError) ? _c('Messages', {
    attrs: {
      "message": _vm.errorText,
      "heightSize": true
    }
  }) : _c('ArticlePage', {
    attrs: {
      "smallHeader": !_vm.isRulesConfirm,
      "name": _vm.pageTitle,
      "infoText": _vm.municipalityName,
      "article": _vm.pageText
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0091bec6","hasScoped":true,"preserveWhitespace":false}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/inquiry/Inquiry.vue
// module id = dd31c7e36384722983e1
// module chunks = 37